import React from 'react';

import { Container, Row, Col, ProgressBar } from 'react-bootstrap';

import { PASSWORD_VALIDATION_TYPES } from 'schema/validation/password';

import './style.css';

const PasswordRules = ({ errors, password }) => {
    const violations = errors?.split(',');
    const passwordStrength = password ? 100 - (violations?.length ?? 0) * 20 : 0;

    return (
        <Container fluid className={`password-rules ${password ? 'touched' : ''}`}>
            <Row>
                <Col>
                    <ProgressBar className={`password-strength-${passwordStrength}`} now={passwordStrength} />
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6}>
                    <div
                        className={`password-rule ${
                            violations?.find((tkey) => tkey === PASSWORD_VALIDATION_TYPES.ONE_LOWERCASE.key)
                                ? 'violation'
                                : ''
                        }`}
                    >
                        One lowercase letter
                    </div>
                    <div
                        className={`password-rule ${
                            violations?.find((tkey) => tkey === PASSWORD_VALIDATION_TYPES.ONE_UPPERCASE.key)
                                ? 'violation'
                                : ''
                        }`}
                    >
                        One uppercase letter
                    </div>
                    <div
                        className={`password-rule ${
                            violations?.find((tkey) => tkey === PASSWORD_VALIDATION_TYPES.MIN_LENGTH_8_CHAR.key)
                                ? 'violation'
                                : ''
                        }`}
                    >
                        Minimum length of 8 characters
                    </div>
                </Col>
                <Col xs={12} sm={6}>
                    <div
                        className={`password-rule ${
                            violations?.find((tkey) => tkey === PASSWORD_VALIDATION_TYPES.ONE_SYMBOL.key)
                                ? 'violation'
                                : ''
                        }`}
                    >
                        One symbol
                    </div>
                    <div
                        className={`password-rule ${
                            violations?.find((tkey) => tkey === PASSWORD_VALIDATION_TYPES.ONE_NUMBER.key)
                                ? 'violation'
                                : ''
                        }`}
                    >
                        One number
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default PasswordRules;
